import { WidgetHeaderType, WidgetFooterType, WidgetType } from '../widget.types';
import { Resource } from '@topconagriculture/permissions';
export const TaskWidgetConfig = {
    type: WidgetType.TASK,
    single: true,
    thumbnail: '/assets/images/dashboard/widget-catalog/tasks.jpg',
    title: 'widget:tasks:title',
    description: 'widget:tasks:description',
    permissions: [Resource.FIELDS],
    header: {
        type: WidgetHeaderType.GENERIC,
    },
    footer: (config) => ({
        type: WidgetFooterType.VIEW_MORE,
        href: config.TASKS_VIEW_MORE_LINK,
        text: 'widget:generic:footer_text',
    }),
    baseConfig: {
        type: WidgetType.TASK,
        w: 1,
        h: 2,
        x: 0,
        y: 0,
    },
};
//# sourceMappingURL=TaskWidgetConfig.js.map